const jobs = {
  bulk: {

    table: {
      direction: {
        to: 'Distribuir',
        from: 'Recolher',
        both: 'Recolher / Distribuir',
      },
    },

    direction: {
      label: 'Direção',
      to: 'Para trabalhar',
      from: 'Do trabalho',
      both: 'Para o trabalho / Do trabalho',
    },

    form: {
      information: {
        passengers: {
          header: 'Selecionar Funcionários',
          fields: {
            passengers: 'Funcionários',
          },
        },

        details: {
          fields: {
            direction: 'Selecione a Direção',
            shift: 'Horário de trabalho'
          },
        },
        locations: {
          header: 'Local de Trabalho',
          fields: {
            locations: 'Selecionar Local de Trabalho'
          }
        },
      },
    },
  },
};

export default jobs;
